import React, { Component } from 'react'
import logo from '../../assets/images/logo.png'
import AsideRightMenu from '../Dashboard/AsideRightMenu'
import { onChange, validateForm } from '../../utils';
import LoiPreview from '../../old_Components/JobApplicationList/LoiPreview';
import Swal from 'sweetalert2'

import { loiformdata, onSendOfferLetter } from '../../action/loiAction';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import constant from '../../constant';
import { UpdateJobResponse } from '../../action/jobs';
class LOI extends Component {
    constructor(props) {
        super(props);
        // const details = props.details
        this.state = {
            Preview: false,
            CREATED_ON: moment(),
            CandidateName: { name: 'CandidateName', value: '', options: [], error: '', isRequired: true },
            DateOfJoining: { name: 'DateOfJoining', value: '', options: [], error: '', isRequired: true },
            ctc: { name: 'ctc', value: '', options: [], error: '', isRequired: true },
            Designation: { name: 'Designation', value: '', options: [], error: '', isRequired: true },
            NoticePeriod: { name: 'NoticePeriod', value: '', options: [], error: '', isRequired: true },
            MedicalInsurance: { name: 'MedicalInsurance', value: '', options: [], error: '', isRequired: false },
            AccidentalInsurance: { name: 'AccidentalInsurance', value: '', options: [], error: '', isRequired: false },
            CompanyLogo: '',
            CompanyName: '',
            Address: '',
            City: '',
            State: '',
            PinCode: '',
            model: {
                CandidateName: '',
                DateOfJoining: '',
                ctc: '',
                Designation: '',
                NoticePeriod: '',
                MedicalInsurance: '',
                AccidentalInsurance: '',
                Address: '',
                City: '',
                State: '',
                PinCode: ''
            }
        }
    }


    componentDidMount() {

        // this.props.location.search
        //  this.props.location.search);
        const qParam = queryString.parse(this.props?.location?.search)
        console.log(qParam, "qparamas");
        loiformdata(qParam).then(res => {

            if (res.status) {
                const { CandidateName, DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Designation } = this.state
                onChange(this, CandidateName.name, res?.result?.CANDIDATE_NAME ? res?.result?.CANDIDATE_NAME : '')
                onChange(this, DateOfJoining.name, res?.result?.DOJ ? res?.result?.DOJ : '')
                onChange(this, ctc.name, res?.result?.CTC ? res?.result?.CTC : '')
                onChange(this, Designation.name, res?.result?.DESIGNATION ? res?.result?.DESIGNATION : '')
                onChange(this, NoticePeriod.name, res?.result?.NOTICE_PERIOD ? res?.result?.NOTICE_PERIOD : '')
                onChange(this, MedicalInsurance.name, res?.result?.MEDICLAIM ? res?.result?.MEDICLAIM : '')
                onChange(this, AccidentalInsurance.name, res?.result?.ACCIDENTAL_INSURANCE ? res?.result?.ACCIDENTAL_INSURANCE : '')
                this.setState({ CREATED_ON: res?.result?.CREATED_ON ? res?.result?.CREATED_ON : moment() })
                this.setState({
                    Address: res.result.ADDRESS,
                    City: res.result.CITY,
                    State: res.result.STATE,
                    PinCode: res.result.PIN_CODE,
                    CompanyLogo: res.result.COMPANY_LOGO,
                    CompanyName: res.result.COMPANY_NAME
                })
            }
        })


    }

    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    onSubmit = (e) => {

        e.preventDefault()
        if (validateForm(this)) {
            const { CandidateName, CompanyName, CompanyLogo, Address, City, State, PinCode, DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Designation, CREATED_ON } = this.state
            const model = {
                CandidateName: CandidateName.value,
                DateOfJoining: DateOfJoining.value,
                ctc: ctc.value,
                Designation: Designation.value,
                NoticePeriod: NoticePeriod.value,
                MedicalInsurance: MedicalInsurance.value,
                AccidentalInsurance: AccidentalInsurance.value,
                CREATED_ON: CREATED_ON,
                CompanyLogo: CompanyLogo,
                CompanyName: CompanyName,
                Address: Address,
                City: City,
                State: State,
                PinCode: PinCode

            }
            this.setState({ model: model, Preview: true })

        }
    }

    onSend = () => {



        const { DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Designation } = this.state
        const qParam = queryString.parse(this.props?.location?.search)
        const model = {

            CANDIDATE_ID: qParam.id,
            JOB_ID: qParam.jid,
            DOJ: DateOfJoining.value,
            CTC: ctc.value,
            DESIGNATION: Designation.value,
            NOTICE_PERIOD: NoticePeriod.value,
            MEDICLAIM: MedicalInsurance.value,
            ACCIDENTAL_INSURANCE: AccidentalInsurance.value
        }
        // this.setState({ model: model, Preview: true })
        let sending = true
        {
            sending && Swal.fire({
                html: 'Sending....',
                didOpen: () => {
                    Swal.showLoading()
                }
            })
        }
        onSendOfferLetter(model).then((res) => {

            if (res.status) {
                // const model = {
                //     STATUS_ID: 10,
                //     CANDIDATE_ID: qParam.id,
                //     JOB_ID: qParam.jid,
                // }
                // UpdateJobResponse(model).then(res => {
                //     if (res.status) {
                //         this.loadlist()
                //     }
                //     sending = false
                //     Swal.fire({
                //         text: res.result.message,
                //         icon: 'success'
                //     }).then(res => {
                //         this.props.history.push(constant.component.JobList.url + '?f=ALL&l=10&p=1')
                //     })
                // })
                sending = false
                Swal.fire({
                    text: res.result.message,
                    icon: 'success'
                }).then(res => {
                    this.props.history.push(constant.component.JobList.url + '?f=ALL&l=10&p=1')
                })
            }
            else {
                Swal.fire({
                    text: res.result.error,
                    icon: 'error'
                })
            }
        })
    }
    render() {
        const { CandidateName, model, DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Preview, Designation } = this.state
        return (
            <React.Fragment>

                {<section className="pricing-area padding-top-70px padding-bottom-80px">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-3 padding-top-70px'>
                                <AsideRightMenu />
                            </div>

                            {
                                Preview && <LoiPreview
                                    model={model}
                                    onSend={() => { this.onSend() }}
                                    onEdit={() => { this.setState({ Preview: false }) }}
                                />
                            }
                            {!Preview && <div className='col-md-9'>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="breadcrumb-content">
                                            <div className="billing-content">
                                                <div className="postjob-form-action">
                                                    <form onSubmit={(e) => (this.onSubmit(e))} >
                                                        <h5 className=' text-secondary mt-5 pb-2'>OFFER DETAILS</h5>
                                                        <p>* Please provide the below details to generate offer letter</p>

                                                        <div className="row">


                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Candidate Name <span className='text-danger font-size-16'>*</span></label>
                                                                <input
                                                                    className={CandidateName.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                    type="text"
                                                                    name={CandidateName.name}
                                                                    value={CandidateName.value}
                                                                    // onChange={this.onChange}
                                                                    placeholder="Enter Candidate Name"
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Date of joining <span className='text-danger font-size-16'>*</span></label>
                                                                <input
                                                                    className={DateOfJoining.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                    type="date"
                                                                    name={DateOfJoining.name}
                                                                    value={DateOfJoining.value}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">CTC <span className='text-danger font-size-16'>*</span></label>
                                                                <input
                                                                    className={ctc.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                    type="text"
                                                                    name={ctc.name}
                                                                    value={ctc.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Enter Offered CTC"
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Designation<span className='text-danger font-size-16'>*</span></label>
                                                                <input
                                                                    className={Designation.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                    type="text"
                                                                    name={Designation.name}
                                                                    value={Designation.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Enter Designation"
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Notice Period <span className='text-danger font-size-16'>*</span></label>
                                                                <select
                                                                    className={NoticePeriod.error.length > 0 ? "postjob-select is-invalid" : "postjob-select"}
                                                                    name={NoticePeriod.name}
                                                                    value={NoticePeriod.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Enter Notice Period"
                                                                >
                                                                    <option>Select Notice Period</option>
                                                                    <option value="5">5 Day's</option>
                                                                    <option value="10">10 Day's</option>
                                                                    <option value="15">15 Day's</option>
                                                                    <option value="20">20 Day's</option>
                                                                    <option value="25">25 Day's</option>
                                                                    <option value="30">30 Day's</option>
                                                                    <option value="45">45 Day's</option>
                                                                    <option value="60">60 Day's</option>
                                                                    <option value="90">90 Day's</option>

                                                                </select>
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Medical Insurance
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name={MedicalInsurance.name}
                                                                    value={MedicalInsurance.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Enter Insured Amount"
                                                                />
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label className="label-text">Accidental Insurance
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name={AccidentalInsurance.name}
                                                                    value={AccidentalInsurance.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Enter Insured Amount"
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <button className='btn btn-primary' style={{ marginTop: "22px" }}>Preview</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </section>}
            </React.Fragment>

        )
    }
}
export default withRouter(LOI)
